export const HOME_ROUTE = "/";
export const FULL_PAGE_WIDGET_ROUTE = `/full-page`;
export const POPUP_WIDGET_TOGGLE_ROUTE = `/popup`;
